/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetConfiguration = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, CorporateStructureLink) {
  'use strict';




  /**
   * The SheetConfiguration model module.
   * @module model/SheetConfiguration
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetConfiguration</code>.
   * @alias module:model/SheetConfiguration
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>SheetConfiguration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetConfiguration} obj Optional instance to populate.
   * @return {module:model/SheetConfiguration} The populated <code>SheetConfiguration</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('OwnerID')) {
        obj['OwnerID'] = ApiClient.convertToType(data['OwnerID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatedDate')) {
        obj['CreatedDate'] = ApiClient.convertToType(data['CreatedDate'], 'Date');
      }
      if (data.hasOwnProperty('LastFetchTimestamp')) {
        obj['LastFetchTimestamp'] = ApiClient.convertToType(data['LastFetchTimestamp'], 'Date');
      }
      if (data.hasOwnProperty('LastFetchError')) {
        obj['LastFetchError'] = ApiClient.convertToType(data['LastFetchError'], 'String');
      }
      if (data.hasOwnProperty('SheetName')) {
        obj['SheetName'] = ApiClient.convertToType(data['SheetName'], 'String');
      }
      if (data.hasOwnProperty('SheetExcelID')) {
        obj['SheetExcelID'] = ApiClient.convertToType(data['SheetExcelID'], 'Integer');
      }
      if (data.hasOwnProperty('SheetGoogleID')) {
        obj['SheetGoogleID'] = ApiClient.convertToType(data['SheetGoogleID'], 'Integer');
      }
      if (data.hasOwnProperty('PerformanceIndicatorID')) {
        obj['PerformanceIndicatorID'] = ApiClient.convertToType(data['PerformanceIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('DataRange')) {
        obj['DataRange'] = ApiClient.convertToType(data['DataRange'], 'String');
      }
      if (data.hasOwnProperty('TimePeriodRange')) {
        obj['TimePeriodRange'] = ApiClient.convertToType(data['TimePeriodRange'], 'String');
      }
      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('PeriodID')) {
        obj['PeriodID'] = ApiClient.convertToType(data['PeriodID'], 'Integer');
      }
      if (data.hasOwnProperty('ForecastDownloadFromSheetRuleID')) {
        obj['ForecastDownloadFromSheetRuleID'] = ApiClient.convertToType(data['ForecastDownloadFromSheetRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('ForecastUploadToSheetRuleID')) {
        obj['ForecastUploadToSheetRuleID'] = ApiClient.convertToType(data['ForecastUploadToSheetRuleID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} OwnerID
   * @default 0
   */
  exports.prototype['OwnerID'] = 0;
  /**
   * @member {Date} CreatedDate
   */
  exports.prototype['CreatedDate'] = undefined;
  /**
   * @member {Date} LastFetchTimestamp
   */
  exports.prototype['LastFetchTimestamp'] = undefined;
  /**
   * @member {String} LastFetchError
   * @default ''
   */
  exports.prototype['LastFetchError'] = '';
  /**
   * @member {String} SheetName
   * @default ''
   */
  exports.prototype['SheetName'] = '';
  /**
   * @member {Integer} SheetExcelID
   */
  exports.prototype['SheetExcelID'] = undefined;
  /**
   * @member {Integer} SheetGoogleID
   */
  exports.prototype['SheetGoogleID'] = undefined;
  /**
   * @member {Integer} PerformanceIndicatorID
   */
  exports.prototype['PerformanceIndicatorID'] = undefined;
  /**
   * @member {String} DataRange
   * @default ''
   */
  exports.prototype['DataRange'] = '';
  /**
   * @member {String} TimePeriodRange
   * @default ''
   */
  exports.prototype['TimePeriodRange'] = '';
  /**
   * @member {Integer} DimensionID
   * @default 0
   */
  exports.prototype['DimensionID'] = 0;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} PeriodID
   * @default 0
   */
  exports.prototype['PeriodID'] = 0;
  /**
   * @member {Integer} ForecastDownloadFromSheetRuleID
   * @default 0
   */
  exports.prototype['ForecastDownloadFromSheetRuleID'] = 0;
  /**
   * @member {Integer} ForecastUploadToSheetRuleID
   * @default 0
   */
  exports.prototype['ForecastUploadToSheetRuleID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


